import { Epic, ofType } from 'redux-observable';
import { EpicDependencies } from '@ui/store/rootEpic';
import * as actions from '../actions';
import { catchError, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';

export const removeCollection: Epic<any, any, any, EpicDependencies> = (
  action$,
  store,
  { collectionApi },
) =>
  action$.pipe(
    ofType(actions.REMOVE_COLLECTION_ACTIONS.REQUESTED),
    switchMap(({ payload: { collectionId } }) =>
      collectionApi.removeCollectionById(collectionId).pipe(
        switchMap(() => of(actions.removeCollectionSucceeded(collectionId))),
        catchError(error => of(actions.removeCollectionFailed(error))),
      ),
    ),
  );



// WEBPACK FOOTER //
// ./src/scenes/Collections/services/epics/removeCollection.ts